// Client wrappers for the tenant WhatsApp Business Profile callables.
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { stripUndefined } from './callable';

export interface BusinessProfile {
  about: string;
  address: string;
  description: string;
  email: string;
  vertical: string;
  websites: string[];
  profilePictureUrl: string | null;
}

type Scoped = { integrationId?: string };

const getCall = httpsCallable<Scoped, { sandbox: boolean; profile: BusinessProfile }>(
  functions, 'whatsappGetBusinessProfile',
);
const updCall = httpsCallable<Partial<BusinessProfile> & Scoped, { sandbox: boolean; profile: BusinessProfile }>(
  functions, 'whatsappUpdateBusinessProfile',
);
const photoCall = httpsCallable<{ imageBase64: string; mimeType: string } & Scoped, { sandbox: boolean }>(
  functions, 'whatsappUpdateProfilePhoto',
);

// Every number has its own Meta business profile, so each call is scoped to
// one (omit → the tenant's default). `stripUndefined` keeps an absent id from
// being sent as null.
export async function getBusinessProfile(integrationId?: string | null) {
  return (await getCall(stripUndefined({ integrationId: integrationId ?? undefined }))).data;
}
export async function updateBusinessProfile(patch: Partial<BusinessProfile>, integrationId?: string | null) {
  return (await updCall(stripUndefined({ ...patch, integrationId: integrationId ?? undefined }))).data;
}
export async function updateProfilePhoto(imageBase64: string, mimeType: 'image/jpeg' | 'image/png', integrationId?: string | null) {
  return (await photoCall(stripUndefined({ imageBase64, mimeType, integrationId: integrationId ?? undefined }))).data;
}

// Meta business verticals + friendly labels for the dropdown.
export const VERTICALS: { value: string; label: string }[] = [
  { value: 'UNDEFINED', label: '—' },
  { value: 'OTHER', label: 'Other' },
  { value: 'AUTO', label: 'Automotive' },
  { value: 'BEAUTY', label: 'Beauty & Spa' },
  { value: 'APPAREL', label: 'Apparel & Clothing' },
  { value: 'EDU', label: 'Education' },
  { value: 'ENTERTAIN', label: 'Entertainment' },
  { value: 'EVENT_PLAN', label: 'Event Planning' },
  { value: 'FINANCE', label: 'Finance & Banking' },
  { value: 'GROCERY', label: 'Grocery' },
  { value: 'GOVT', label: 'Government' },
  { value: 'HOTEL', label: 'Hotel & Lodging' },
  { value: 'HEALTH', label: 'Medical & Health' },
  { value: 'NONPROFIT', label: 'Non-profit' },
  { value: 'PROF_SERVICES', label: 'Professional Services' },
  { value: 'RETAIL', label: 'Shopping & Retail' },
  { value: 'TRAVEL', label: 'Travel & Transport' },
  { value: 'RESTAURANT', label: 'Restaurant' },
  { value: 'NOT_A_BIZ', label: 'Non-business' },
];
